import { useState, useEffect, ReactNode } from 'react'

export interface Props {
  limit: number,
  className?: string,
  children: string,
  readMoreButtonText: ReactNode,
  collapse: boolean,
  onExpand: () => void
}

const collapseText = (text: string, limit: number) => {
  let subText = text.substr(0, limit)

  if (text.length > limit) {
    subText = `${subText}${'...'}`
  }
  return subText
}

const LimitedParagraph = ({
  className, children = '', limit, readMoreButtonText, collapse, onExpand
}: Props) => {
  const [text, setText] = useState(collapseText(children, limit))

  useEffect(() => {
    collapse && setText(collapseText(children, limit))
  }, [collapse, children, limit])

  return (
    <p className={className}>
      {text} {children.length > limit && collapse && (
        <button className="a" onClick={onExpand}>
          {readMoreButtonText}
        </button>
      )}
    </p>
  )
}

export default LimitedParagraph
